/**Dependencies */
import React from "react";

/**Components */
import { PrincipalBanner } from "../components/PrincipalBanner";
import { Container, Row, Col } from "react-bootstrap";

/**Styles */
import "../styles/nosotros.scss";

/**Images */
import confianza from "../images/Confianza.png";
import calidad from "../images/Calidad.png";
import honestidad from "../images/Honestidad.png";
import puntualidad from "../images/Puntualidad.png";

export const Nosotros = () => {
  return (
    <div className="nosotros">
      <PrincipalBanner idElemento={11} />

      <Container className="py-5">
        <div className="text-center">
          <h1 className="section-title outline mb-5">¿Quiénes somos?</h1>
        </div>
      </Container>
      <div className="py-5">
        <div className="section-historia">
          <Row className="w-100 align-items-center">
            <Col
              xs={12}
              md={4}
              className="d-flex align-items-center justify-content-center mb-3 mb-md-0"
            >
              <h2>
                Nuestra <br /> historia
              </h2>
            </Col>

            <Col
              xs={12}
              md={8}
              style={{ textAlign: "justify", padding: "35px" }}
            >
              <p>
                Empresa Mexicana que nace en 1997 adoptando como sede
                Cuernavaca, Morelos, con la firme convicción de satisfacer las
                necesidades del mercado respecto a un servicio profesional,
                serio y comprometido.
              </p>
              <br />
              <p>
                Las Agencias de Viajes tienen el privilegio de ser el contacto
                final entre el Cliente y Proveedores prestadores de Servicios,
                por lo que el compromiso que debemos asumir quienes nos
                dedicamos a este sector es de absoluto respeto a nuestro
                cliente, constante preparación y profesionalismo.
              </p>
              <br />
              <p>
                Es el Cliente el actor principal en esta dinámica comercial, por
                lo que nos debemos a él y para él.
              </p>
            </Col>
          </Row>
        </div>
      </div>
      <div className="py-5">
        <div className="section-mision py-5">
          <Row className="w-100 align-items-center">
            <Col
              xs={12}
              md={8}
              style={{ textAlign: "justify", padding: "35px" }}
            >
              <p>
                International Travel Net se mantiene en constante renovación y
                desarrollando la actitud positiva de Servicio que se requiere en
                este mundo tan dinámico y diverso en donde la comunicación es la
                médula de la actividad Social, Cultural y Financiera.
              </p>
              <br />
              <p>
                Nuestra empresa tiene perfectamente identificadas las
                necesidades de los diferentes ramos de nuestros pasajeros como
                son: Viajes de Negocios en México y el Extranjero, Vacaciones en
                México y el Extranjero, Eco Turísmo, Cruceros, Honeymooners,
                Graduaciones y todas las necesidades que derivan de estas
                preferencias.
              </p>
              <br />
              <p>
                En International Travel Net valoramos nuestros veinte años de
                experiencia, aplicándolos para ofrecer hoy asesoría profesional,
                con objetivos al futuro inmediato de superación y constante
                evolución.
              </p>
            </Col>
            <Col
              xs={12}
              md={4}
              className="d-flex align-items-center justify-content-center mb-3 mb-md-0"
            >
              <h2>Misión</h2>
            </Col>
          </Row>
        </div>
      </div>
      <div className="py-5">
        <Container>
          <h1 className="mb-5" style={{ fontSize: "50px" }}>
            Los principales valores
          </h1>
          <Row className="text-center">
            <Col lg={3} md={6} sm={12} className="mt-5">
              <img
                src={confianza}
                alt="banner confianza"
                style={{ width: "80%" }}
              />
            </Col>
            <Col lg={3} md={6} sm={12} className="mt-5">
              <img
                src={calidad}
                alt="banner calidad"
                style={{ width: "80%" }}
              />
            </Col>
            <Col lg={3} md={6} sm={12} className="mt-5">
              <img
                src={honestidad}
                alt="banner honestidad"
                style={{ width: "80%" }}
              />
            </Col>
            <Col lg={3} md={6} sm={12} className="mt-5">
              <img
                src={puntualidad}
                alt="banner puntualidad"
                style={{ width: "80%" }}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};
